import { ChatModel } from '@/models/chat.model'
import { put } from 'redux-saga/effects'
import { pauseChatAction } from '../../actions'
import { update } from '../_http/chat'

export function* pauseChatSaga(action: ReturnType<typeof pauseChatAction.request>) {
  const { activeChat, currentOperatorId } = action.payload
  try {
    updateChatDurationsOnPause(activeChat, currentOperatorId)
    const updatedData: Partial<ChatModel> = {
      durations: activeChat?.durations,
      isPaused: true
    }
    yield update(activeChat.id, { ...updatedData, updatedAt: new Date().getTime() })
    yield put(pauseChatAction.success({ updatedChatData: updatedData }))
  } catch (error) {
    console.error('Error when starting chat:', error)
    yield put(pauseChatAction.failure(error))
  }
}

function updateChatDurationsOnPause(activeChat: ChatModel, operatorId: string) {
  const currentDuration = findDuration(activeChat)
  if (currentDuration?.operatorId) {
    const currentPeriod = currentDuration.periods.find(period => !period?.endTime)
    currentPeriod.endTime = Date.now()
  }
}

function findDuration(activeChat: ChatModel) {
  const durations = activeChat?.durations ?? []
  const duration = durations.find(duration => duration.periods.some(period => !period?.endTime))
  return duration
}
